import { useSyncExternalStore } from 'react'
import { getEventPicks, getTotalPickCount, subscribeGuestPicks, type LocalPicks } from '../lib/guestSetPicks'

export function useGuestSetPicks(eventId: string): LocalPicks {
  return useSyncExternalStore(subscribeGuestPicks, () => getEventPicks(eventId))
}

export function useGuestPickCount(): number {
  return useSyncExternalStore(subscribeGuestPicks, getTotalPickCount)
}
